<ng-template #otherAccessTemplate>
  <ng-container *ngIf="accessPointCounts || lockCount">
    <img src="assets/images/accesspoint-icon.png" class="icon" />
    <span class="ml-2 mt-1 text d-flex flex-column">
      <span class="title">
        <app-with-tooltip [showHelpCursor]="true">
          {{ accessPointCounts }}
        </app-with-tooltip>
      </span>
      <p class="sub-title">
        <app-with-tooltip [showHelpCursor]="true">
          {{ "ACCESS_POINTS" | translate }}
        </app-with-tooltip>
      </p>
    </span>
  </ng-container>
</ng-template>

<ng-template #lockTemplate>
  <ng-container *ngIf="lockCount || accessPointCounts">
    <img src="assets/svg/ico-lock-circle.svg" class="icon" />
    <span class="pl-2 pt-1 text d-flex flex-column col-8">
      <span class="title">
        <app-with-tooltip [showHelpCursor]="true">
          {{ lockCount }}
        </app-with-tooltip>
      </span>
      <p class="sub-title">
        {{ "USER_LOCKS" | translate }}
      </p>
    </span>
  </ng-container>
</ng-template>

<div class="user-detail-main px-4 mb-5">
  <div class="row mt-5 mb-1">
    <div class="col-lg-12 col-xl-2">
      <div
        *ngIf="profileDetails?.name"
        class="avatar-container text-center text-lg-left"
      >
        <span
          class="avatar-box pointer-cursor profile-pic"
          (click)="viewProfile()"
        >
          <app-profile-picture
            [name]="profileDetails?.name"
            [userData]="profileDetails"
          >
          </app-profile-picture>
          <img
            *ngIf="getNotExpiredTempRecords?.length > 0"
            src="assets/images/circle-time-red-trimmy.png"
            class="time"
            alt="circle-time-red"
          />
        </span>
      </div>
    </div>
    <div class="col-lg-12 col-xl-10">
      <div class="row">
        <div
          class="col-12 main-heading justify-content-lg-between justify-content-center text-lg-left text-center d-flex"
        >
          <div class="text-height d-flex overflow-ellipsis ml-3">
            <app-with-tooltip [showHelpCursor]="true" class="overflow-ellipsis">
              {{ profileDetails?.firstName }} {{ profileDetails?.lastName }}
            </app-with-tooltip>
          </div>
          <div class="position-relative">
            <button
              class="add-user btn outline-none pointer-cursor float-right pr-1"
            >
              <!-- this is modal button for user group -->
              <img
                (click)="viewProfile()"
                src="assets/svg/ico-lock-access-settings.svg"
              />
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="col-12 setting-icon">
            <div class="row justify-content-between mt-3">
              <div
                class="col-6 col-lg-6 justify-content-center d-flex cursor-default"
              >
                <img src="assets/images/group-icon.png" class="icon" />
                <span class="pl-2 pt-1 text d-flex flex-column col-8">
                  <span class="title">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ profileDetails?.userType | translate }}
                    </app-with-tooltip>
                  </span>
                  <span class="sub-title">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ "USER_TYPE" | translate }}
                    </app-with-tooltip>
                  </span>
                </span>
              </div>
              <div
                class="col-6 col-lg-6 justify-content-center d-flex m-auto cursor-default"
              >
                <ng-container *ngIf="commonAccessControl">
                  <ng-container
                    *ngTemplateOutlet="otherAccessTemplate"
                  ></ng-container>
                </ng-container>

                <ng-container *ngIf="!commonAccessControl">
                  <ng-container *ngTemplateOutlet="lockTemplate"></ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 py-2">
          <div class="col-12 setting-icon">
            <div class="row justify-content-between mt-2">
              <div
                class="col-6 col-lg-4 justify-content-center offset-lg-2 d-flex cursor-default"
              >
                <ng-container *ngIf="commonAccessControl">
                  <ng-container *ngTemplateOutlet="lockTemplate"></ng-container>
                </ng-container>
              </div>
              <div
                class="col-6 col-lg-4 justify-content-center d-flex cursor-default"
              >
                <span class="mt-1 text d-flex flex-column w-100 pr-1">
                  <span
                    class="personal-detail text-center text-lg-right email-text"
                  >
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ profileDetails?.phoneNumber }}
                    </app-with-tooltip>
                  </span>
                  <p
                    class="personal-detail text-center text-lg-right email-text"
                  >
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ profileDetails?.email }}
                    </app-with-tooltip>
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!allAccess">
    <div class="w-100 pt-3 user-detail-body content position-relative">
      <ul
        ngbNav
        #nav="ngbNav"
        [(activeId)]="activeTab"
        class="nav-tabs w-100 mb-3"
        [class.tab-disabled]="
          disabledHomeAccess && disabledOtherAccess && disabledTemporaryAccess
        "
      >
        <li
          ngbNavItem="homeAccess"
          [disabled]="disabledHomeAccess"
          [class.not-allowed]="disabledHomeAccess"
        >
          <a ngbNavLink class="pointer-cursor">{{
            "HOME_ACCESS" | translate
          }}</a>
          <ng-template ngbNavContent>
            <div class="access-user-container" *ngIf="!disabledHomeAccess">
              <div class="scroll-container">
                <div class="overflow-y">
                  <app-user-list-items
                    [listItems]="profileDetails?.userAccess?.homeAccess"
                    [userType]="profileDetails?.userType"
                    (homeAccessOnClick)="homeAccessOnClick($event)"
                  >
                  </app-user-list-items>
                </div>
              </div>
            </div>
            <app-dashboard-user-access-message
              *ngIf="
                this.profileDetails?.userAccess?.temporaryAccess.length === 0 &&
                this.profileDetails?.userAccess?.homeAccess.length === 0 &&
                this.profileDetails?.userAccess?.otherAccess.length === 0 &&
                !allAccess
              "
              [title]="'NO_LOCKS_PRESENT' | translate"
              [description]="'NO_LOCKS_ARE_PRESENT_IN_SHARED_UNITS' | translate"
            >
              <div class="all-access-container">
                <div class="no-locks-message"></div>
              </div>
            </app-dashboard-user-access-message>
            <app-user-access-expired-default
              *ngIf="disabledHomeAccess && allAccess === false"
            ></app-user-access-expired-default>
          </ng-template>
        </li>
        <ng-container *appHideAccess="commonAccessControl">
          <li
            class="px-70"
            ngbNavItem="anotherAccess"
            [disabled]="disabledOtherAccess"
            [class.not-allowed]="disabledOtherAccess"
          >
            <a ngbNavLink class="pointer-cursor">{{
              "OTHER_ACCESS" | translate
            }}</a>
            <ng-template ngbNavContent>
              <div class="access-user-container">
                <div class="scroll-container">
                  <div class="overflow-y">
                    <app-user-list-items
                      [listItems]="profileDetails?.userAccess?.otherAccess"
                      [userType]="profileDetails?.userType"
                      (homeAccessOnClick)="homeAccessOnClick($event)"
                    >
                    </app-user-list-items>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
        </ng-container>
        <li
          ngbNavItem="temporaryAccess"
          [disabled]="disabledTemporaryAccess"
          [class.not-allowed]="disabledTemporaryAccess"
        >
          <a ngbNavLink class="pointer-cursor">
            {{ "TEMPORARY_ACCESS" | translate }}</a
          >
          <ng-template ngbNavContent>
            <div class="access-user-container">
              <div class="scroll-container">
                <div class="overflow-y">
                  <app-user-list-items
                    [listItems]="profileDetails?.userAccess?.temporaryAccess"
                    [userType]="profileDetails?.userType"
                    (homeAccessOnClick)="homeAccessOnClick($event)"
                  >
                  </app-user-list-items>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </ng-container>
  <ng-container *ngIf="allAccess">
    <div class="all-access-container">
      <app-dashboard-user-access-message
        [title]="'COMPREHENSIVE_ACCESS' | translate"
        [description]="textDescription"
      ></app-dashboard-user-access-message>
    </div>
  </ng-container>
  <ng-container
    *sameUserIdControl="{
      userId: profileDetails?.email,
      hide: true,
      hideSameAndLowerRoles: CONSTANTS.PROPERTY_MANAGER_USER,
      currentRole: profileDetails?.userType
    }"
  >
    <div
      class="d-flex flex-row justify-content-center align-items-center d-none"
    >
      <p class="remove-btn ml-2 pt-2 mb-3" (click)="removeUser()" type="button">
        <img src="assets/svg/ico-close-circle-outline.svg" />
        {{ "DELETE_USER" | translate }}
      </p>
    </div>
  </ng-container>
</div>
